import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { CallbackPage } from "@/auth/CallbackPage";
import { SilentRenewPage } from "@/auth/SilentRenewPage";
import { AdminShell } from "@/features/shell/AdminShell";
import { DashboardPage } from "./pages/DashboardPage";
import { TenantsPage } from "@/features/tenants/TenantsPage";
import { ConnectPoliciesPage } from "@/features/tenants/ConnectPoliciesPage";
import { DistributionListsPage } from "@/features/mail/DistributionListsPage";
import { IdentityProvidersPage } from "@/features/identity-providers/IdentityProvidersPage";
import { ServiceProvidersPage } from "@/features/identity-providers/ServiceProvidersPage";
import { AuditPage } from "@/features/audit/AuditPage";
import { MobilePage } from "@/features/mobile/MobilePage";

function ProtectedShell() {
    return (
        <ProtectedRoute>
            <AdminShell />
        </ProtectedRoute>
    );
}

export function App() {
    return (
        <>
            <Routes>
                <Route path="/auth/callback" element={<CallbackPage />} />
                <Route path="/auth/silent-renew" element={<SilentRenewPage />} />
                <Route element={<ProtectedShell />}>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/tenants" element={<TenantsPage />} />
                    <Route path="/distribution-lists" element={<DistributionListsPage />} />
                    <Route path="/connect-policies" element={<ConnectPoliciesPage />} />
                    <Route path="/mobile" element={<MobilePage />} />
                    <Route path="/identity-providers" element={<IdentityProvidersPage />} />
                    <Route path="/service-providers" element={<ServiceProvidersPage />} />
                    <Route path="/audit" element={<AuditPage />} />
                </Route>
            </Routes>
        </>
    );
}
